import React, { useEffect, useState } from 'react';

import { StudioApplicationBase } from 'jamespot-user-api';

import { JRCModalLayout } from 'components/JRCModal/JRCModalLayout';
import { JRCModalContent } from 'components/JRCModal/JRCModalContent';

import { JRCButton } from 'components/JRCButton/JRCButton';
import { JRCLoader } from 'components/JRCLoader/JRCLoader';

import { FormattedMessage, useIntl } from 'react-intl';
import { StudioEditorApp } from './StudioEditorApp';
import { DATASOURCE_TYPE, SUPPORTED_DISPLAY_TYPE } from '../../const';
import { useEditorContext } from 'components/Widgets/context/hooks';
import { WidgetDatasourceContext } from '../../JRCWidgetDatasourceTableEditor';

export const StudioEditorFetch = () => {
    const intl = useIntl();
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [list, setList] = useState<StudioApplicationBase[]>([]);

    const { handlers, onChange, onError } = useEditorContext<WidgetDatasourceContext>();

    useEffect(() => {
        if (isOpen) {
            setIsLoading(true);
            handlers.jamespot.application
                .studioList()
                .then((response) => {
                    setList(response.result);
                })
                .catch(handlers.handleCatch)
                .finally(() => setIsLoading(false));
        }
    }, [isOpen, onError, handlers]);

    const onHandleSelection = (article: StudioApplicationBase) => {
        if (!article.label) {
            return;
        }
        setIsOpen(false);

        handlers.jamespot.datasource
            .create({
                title: article.label,
                datasourceIdentifier: article.idApp,
                datasourceType: DATASOURCE_TYPE.STUDIO,
            })
            .then((response) => {
                onChange({
                    tableColumnsData: response.result.model.map((el) => {
                        return { name: el.name, isVisible: SUPPORTED_DISPLAY_TYPE.includes(el.type) };
                    }),
                    uri: response.result.uri,
                });
            })
            .catch(handlers.handleCatch)
            .finally(handlers.handleFinally);
    };

    return (
        <>
            <JRCButton onClick={() => setIsOpen(true)} variant={'outlined'} minWidth={'100%'} noMargin>
                {intl.formatMessage({ id: 'WIDGET_Datasource_Fetch_Studio' })}
            </JRCButton>
            {isOpen && (
                <JRCModalLayout enableClickAwayCloseModal={true} open={isOpen} closeHandler={() => setIsOpen(false)}>
                    <JRCModalContent
                        title={intl.formatMessage({ id: 'WIDGET_Datasource_Fetch_Studio' })}
                        overflow={'scroll'}
                        onClickIconClose={() => setIsOpen(false)}>
                        {isLoading && <JRCLoader size={'m'} />}
                        {!isLoading && list.length === 0 ? (
                            <FormattedMessage id={'WIDGET_Datasource_Fetch_Studio_Empty_Result'} />
                        ) : (
                            <></>
                        )}
                        {list
                            .filter((app) => app.status === 'installed')
                            .map((app) => {
                                return (
                                    <StudioEditorApp
                                        key={app.idApp}
                                        idApp={app.idApp}
                                        status={app.status}
                                        onHandleSelection={onHandleSelection}
                                        onError={onError}
                                    />
                                );
                            })}
                    </JRCModalContent>
                </JRCModalLayout>
            )}
        </>
    );
};
